// Wording of the daily report and the monthly dashboard (handoff v08 #25, #26) — pure functions over i18n, shared by
// the screens, the printout, the CSV and the wording tests (tests/unit/performance.test.ts: no causal verbs, no
// pressure words, in el / en / ru).
import type { FeedbackLine, Line, Rate, RateKey, ReportMetric } from '@vero/domain';

export interface Fmt { t: (key: string, params?: Record<string, string | number>) => string; num: (n: number) => string; month: (m: string) => string }
const pct = (f: Fmt, n: number | null | undefined) => (n === null || n === undefined ? '—' : `${f.num(n)}%`);
export const rateLabel = (f: Fmt, k: RateKey) => f.t(`monthly.rate.${k}`);
export const metricLabel = (f: Fmt, k: ReportMetric) => f.t(`dayreport.metric.${k}`);
/** "x of y (z%)" — every rate with its denominator */
export function rateText(f: Fmt, r: Rate): string {
  return r.den ? f.t('dayreport.x_of_y', { x: f.num(r.num), y: f.num(r.den), pct: pct(f, r.value) }) : f.t('dayreport.no_denominator');
}
export function feedbackText(f: Fmt, l: FeedbackLine): string { return f.t(`dayreport.fb.${l.key}`, l.params); }
/** one interpretation or priority line, numbers quoted */
export function monthLineText(f: Fmt, l: Line, kind: 'line' | 'prio' = 'line'): string {
  const p: Record<string, string | number> = { ...l.params };
  if (typeof p.rate === 'string') p.rate = rateLabel(f, p.rate as RateKey);
  if (typeof p.metric === 'string') p.metric = metricLabel(f, p.metric as ReportMetric);
  if (typeof p.month === 'string') p.month = f.month(p.month);
  for (const k of ['pct', 'ppct', 'diff']) if (typeof p[k] === 'number') p[k] = pct(f, p[k] as number);
  for (const k of ['now', 'prev', 'avg']) if (typeof p[k] === 'number') p[k] = f.num(p[k] as number);
  return f.t(`monthly.${kind}.${l.key}`, p);
}
